import { useTranslation } from "react-i18next";
import Mui5 from "components/mui5";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Grid from "components/primitives/Grid";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

interface InfoCardProps {
  title: string;
  icon?: JSX.Element;
  children?: React.ReactNode;
  onClose?(): void;
}

function InfoCard(props: InfoCardProps) {
  const { t } = useTranslation();

  return (
    <Mui5.Paper sx={{ maxHeight: "100%", p: 3, overflowY: "auto" }}>
      {props.onClose && (
        <IconButton
          sx={{ position: "absolute", top: 12, right: 12 }}
          onClick={props.onClose}
          aria-label={t("global.close_label")}
        >
          <CloseIcon />
        </IconButton>
      )}
      <Grid container flexDirection="column" sx={{ width: "100%" }}>
        <Grid container sx={{ width: "100%" }}>
          <Grid>
            <Typography variant="h1" gutterBottom>
              {props.title}
            </Typography>
          </Grid>
          {props.icon && (
            <Grid height="24px" pl={0.5}>
              {props.icon}
            </Grid>
          )}
        </Grid>
        <Grid size={12}>
          <Divider sx={{ my: 1 }} />
        </Grid>
        <Grid size={12} flex={1}>
          {props.children}
        </Grid>
      </Grid>
    </Mui5.Paper>
  );
}

export default InfoCard;
